export default "__VITE_ASSET__C9c8gepc__"